var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-man"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    "data-name": "Rectangle 1740",
    width: 64,
    height: 64,
    rx: 15,
    fill: "#132320",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MAN",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1736",
    "data-name": "Rectangle 1736",
    fill: "none",
    stroke: "#132320",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 66,
    height: 66,
    rx: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_72",
    "data-name": "Mask Group 72",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-man)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_006-man",
    "data-name": "006-man",
    d: "M110.661,46.291a4.5,4.5,0,0,1-3.868-2.171,1.082,1.082,0,0,0-1.849,1.126,6.68,6.68,0,0,0,2.264,2.256l-1.122,5.09-2.7-3.114a1.084,1.084,0,1,0-1.577-1.485l-1.9,2.188-4.793-5.326c.408-.783.632.492.7-.4,11.05,3.469,18.58-6.4,18.58-16.024v-10.3a1.082,1.082,0,0,0-2.165,0v10.3A12.324,12.324,0,0,1,96.669,40.3V37.068a3.247,3.247,0,1,1,6.494,0c0,.6-.157,5.794,1.191,4.712s.973-4.114.973-4.712a5.411,5.411,0,1,0-10.823,0v2.415a12.325,12.325,0,0,1-6.9-11.056V19.242a6.11,6.11,0,0,0,5.682-4.809,37.093,37.093,0,0,0,7.342,3.63,36.078,36.078,0,0,0,7.669,1.878,1.082,1.082,0,0,0,.149-2.154A34.88,34.88,0,0,1,93.1,11.7a1.084,1.084,0,0,0-1.708.89,4.925,4.925,0,0,1-2.046,3.936,4.454,4.454,0,0,1-2.824.522,1.086,1.086,0,0,0-.991.647c-.127.288-.092-.327-.092,8.971a2.235,2.235,0,0,1-1.218-1.98V14.543A12.393,12.393,0,0,1,96.6,2.165h6.764a12.393,12.393,0,0,1,12.379,12.379V24.684a1.082,1.082,0,1,0,2.165,0V14.543A14.559,14.559,0,0,0,103.366,0H96.6A14.559,14.559,0,0,0,82.059,14.543V24.684a4.416,4.416,0,0,0,3.393,4.278c.2,5.528,3.517,12.537,8.241,14.8V41.78a4.512,4.512,0,0,1-4.522,4.511A11.164,11.164,0,0,0,78,57.461v6.393a1.082,1.082,0,1,0,2.165,0V57.461a8.983,8.983,0,0,1,3.975-7.472V63.854a1.082,1.082,0,1,0,2.165,0V48.921c2.1-.7,2.771-.294,4.28-.616l1.51,6.854a1.083,1.083,0,0,0,1.874.477l3.894-4.484c1.366,1.518,1.379,1.591,1.743,1.7a1.077,1.077,0,0,0,.927-.148c.139-.1.06-.017,1.415-1.576l3.915,4.508a1.083,1.083,0,0,0,1.874-.477l1.51-6.854a6.8,6.8,0,0,0,1.414.15,9,9,0,0,1,9.006,9.006v6.393a1.082,1.082,0,1,0,2.165,0V57.461a11.164,11.164,0,0,0-11.171-11.171Zm-16.915,6.3L92.624,47.5a6.721,6.721,0,0,0,1.156-.885L96.4,49.53Zm21.946-.165V63.854a1.082,1.082,0,1,1-2.165,0V52.426a1.082,1.082,0,1,1,2.165,0Z",
    transform: "translate(-67.909 4.143)",
    fill: "#132320"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManIcon);
export default __webpack_public_path__ + "static/media/man-icon.e91c8af8.svg";
export { ForwardRef as ReactComponent };